import React from 'react';

import classNames from 'classnames/bind';
import style from './Fact.scss';
const ctx = classNames.bind(style);

const Fact = props => (
  <div>
    <div className={ctx('article-fact')}>
      <div className={ctx('fact')}>{props.children}</div>
      <div className={ctx('source')}>{props.source}</div>
    </div>
  </div>
);

export default Fact;
